import { Injectable } from '@angular/core';
import { NoticeService } from '@df/ui/api/notice/notice.service';
import { TranslationService } from '@df/ui/translation/translation.service';

@Injectable({
    providedIn: 'root'
})
export class TranslationNoticeService extends NoticeService {
    constructor(private translationService: TranslationService) {
        super();
    }

    override transform(input: string | number, successMsg?: string): string | undefined {
        const message = super.transform(input, successMsg);

        return message ? this.translationService.translate(message) : undefined;
    }
}
